import React, { useEffect } from 'react';
import { Box, Checkbox, FormControlLabel, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { deriveAutoSubmit } from './index';

const useStyles = makeStyles(() => ({
    sectionTitle: { fontSize: 15, fontWeight: 'bold', margin: '16px 0 6px' },
    row: { marginBottom: 6 },
    label: { color: '#555', marginRight: 4 },
    value: { fontWeight: 'bold' },
    note: { color: '#555', fontSize: 13, marginTop: 8 },
}));

export default function ReviewStep({ store, formData, isFinished }) {
    const classes = useStyles();

    const { mobilePlatform, appType, isNewApp } = formData;
    const isProduction = appType === 'production';
    const isTesting = appType === 'testing';
    const isIOS = mobilePlatform === 'ios';
    const isAndroid = mobilePlatform === 'android';

    const buildProfile = isProduction ? 'store-production' : 'store-staging';
    const autoSubmit = deriveAutoSubmit(formData);

    useEffect(() => { isFinished(false); }, []);

    const envLabel = isProduction ? 'Produção' : 'Homologação';
    const platformLabel = isAndroid ? 'Android' : 'iOS';
    const autoSubmitLabel = autoSubmit
        ? 'Sim (build enviado automaticamente para a loja)'
        : 'Não (envio manual necessário após o build)';

    const bundleId = isAndroid
        ? _.get(store, 'platforms.android.bundleId')
        : _.get(store, 'platforms.ios.packageName');

    return (
        <Grid container direction="column">
            <Typography className={classes.sectionTitle}>Resumo da publicação</Typography>

            <Box className={classes.row}>
                <span className={classes.label}>Loja:</span>
                <span className={classes.value}>{store.title}</span>
            </Box>
            <Box className={classes.row}>
                <span className={classes.label}>Plataforma:</span>
                <span className={classes.value}>{platformLabel}</span>
            </Box>
            <Box className={classes.row}>
                <span className={classes.label}>Ambiente:</span>
                <span className={classes.value}>{envLabel}</span>
            </Box>
            {isProduction && (
                <Box className={classes.row}>
                    <span className={classes.label}>Aplicativo novo:</span>
                    <span className={classes.value}>{isNewApp === true ? 'Sim' : 'Não'}</span>
                </Box>
            )}
            <Box className={classes.row}>
                <span className={classes.label}>Bundle ID:</span>
                <span className={classes.value}>{bundleId || '-'}</span>
            </Box>
            <Box className={classes.row}>
                <span className={classes.label}>Perfil de build:</span>
                <span className={classes.value}>{buildProfile}</span>
            </Box>
            <Box className={classes.row}>
                <span className={classes.label}>Auto-submit:</span>
                <span className={classes.value}>{autoSubmitLabel}</span>
            </Box>

            {isTesting && (
                <Typography className={classes.note}>
                    {isAndroid
                        ? 'Um APK será gerado para instalação direta em dispositivos Android.'
                        : 'Um IPA Ad Hoc será gerado para instalação em devices registrados na conta Apple desta loja.'}
                </Typography>
            )}

            {isAndroid && isProduction && !autoSubmit && (
                <Typography className={classes.note}>
                    Após o build, baixe o <strong>.aab</strong> em "Publicações (expo)" e envie manualmente para o Google Play.
                </Typography>
            )}

            {isIOS && isProduction && (
                <Typography className={classes.note}>
                    Após o build, acesse "Publicações (expo)" → "Concluir publicação" para selecionar a compilação na App Store Connect e enviar para revisão.
                </Typography>
            )}

            <Box mt={3}>
                <FormControlLabel
                    control={<Checkbox onChange={(e) => isFinished(e.target.checked)} />}
                    label="Confirmo que realizei todos os passos necessários e estou pronto para iniciar a publicação."
                />
            </Box>
        </Grid>
    );
}
